import React from "react";
import { Dropdown } from "antd";
import { useGenericStore } from "../../../store/zustandGenericStore";

function IWContextMenu() {
  // Menu-States werden hier isoliert abonniert
  const displayModalMenu = useGenericStore(state => state.displayModalMenu);
  const displayModalMenuItems = useGenericStore(state => state.displayModalMenuItems);
  const displayModalMenuPosX = useGenericStore(state => state.displayModalMenuPosX);
  const displayModalMenuPosY = useGenericStore(state => state.displayModalMenuPosY);

  return (
    <Dropdown 
      open={displayModalMenu} 
      menu={{ items: displayModalMenuItems }} 
      trigger={["click"]} 
      autoFocus={true}
    >
      <p
        style={{
          position: "absolute",
          left: displayModalMenuPosX - 20,
          top: displayModalMenuPosY - 20,
          width: 1,
          height: 1,
        }}
      />
    </Dropdown>
  );
}

export default React.memo(IWContextMenu);